import * as React from "react";
import App from "./App";
import axios from "axios";
import { Constants } from "./constants";
import { UserInterface, UserContext } from './components/common/UserContext';

interface AppState {
  user: UserInterface;
}

class PrivateApp extends React.Component<any,AppState> {
    // Contructor
  constructor(props: any) {
    super(props);

    this.state = {
        user: {name: '', isReadOnly: true},
    };
  }

  /**
   * Force the loading of the user data once the page is rendered
   */
  componentDidMount() {
    this.getUser();
  }

  /**
  * Fetch user Data
  */
  getUser = () => {
    // For tests
    const URI_PRE = ""; 
    let URI: string = URI_PRE + Constants.BANKLIST_USER_URI;

    axios
      .get(URI)
      .then(resp => {
          let name = resp.data.name;
          let isReadOnly = resp.data.isReadOnly;
          this.setState({
            user: { name: name, isReadOnly: isReadOnly }
          });
      })
      .catch(err => {
          console.log(err);
          this.setState({
            user: { name: 'Unknown User', isReadOnly: true }
          });
          return null;
      });
  };

  public render() {
    return (
      <UserContext.Provider value={this.state.user}>
        <App  {...this.props}/>
      </UserContext.Provider>
    );
  }
}

export default PrivateApp;
